// @flow
import { shapeNames } from '@src/utils/displayMaps';
import type { DiamondType } from '@types/diamond';

type ImageType = {
  small: string,
  full: string,
  prong: string
};

type ShapeImagesType = {
  AS?: ImageType,
  B?: ImageType,
  C?: ImageType,
  E?: ImageType,
  H?: ImageType,
  M?: ImageType,
  O?: ImageType,
  P?: ImageType,
  PR?: ImageType,
  R?: ImageType
};

const shapeImages: ShapeImagesType = {};

for (let shape in shapeNames) {
  shapeImages[shape] = {
    small: `/images/shapes/${shape}.jpg`,
    full: `/images/shapes/${shapeNames[shape].toLowerCase()}.gif`,
    prong: `/images/shapes/${shapeNames[shape].toLowerCase()}_prong.gif`
  };
}

export function getDiamondFilledSetting (uri: string): string {
  let parts = uri.split('?');
  parts[2] = 'obj=stones&g_Center=fdiamonds&fullcut&show&' + parts[2];
  return parts.join('?');
}

export function shapeImagePath (diamond: DiamondType): string {
  const images: Object = shapeImages[diamond.shape];
  return images['small'];
}

export function shapeProngImagePath (diamond: DiamondType): string {
  const images: Object = shapeImages[diamond.shape];
  return images['prong'];
}

export function fullSizeShapeImagePath (diamond: { shape: string }): string {
  const images: Object = shapeImages[diamond.shape];
  return images['full'];
}

export function compareDiamondDimensions (
  diamond: DiamondType
): { height: string | number, width: string | number } {
  try {
    const rockHeight: number = Math.round(diamond.measure_length * 3.414);
    const rockWidth: number = Math.round(
      parseFloat(rockHeight) / parseFloat(diamond.length_width_ratio)
    );

    return {
      height: rockHeight,
      width: rockWidth
    };
  } catch (_e) {
    return {
      height: 'auto',
      width: 'auto'
    };
  }
}
